import React from 'react';
import Calculator from './Calculator';
import './HomePage.css';

function HomePage({ isRegistered, userEmail, onShowSignupModal, onCalculate }) {
  return (
    <div className="home-page">
      <header className="hero-section">
        <h1>Your Amazon FBA Removal Order Fee Calculator</h1>
        <p className="hero-subtitle">
          Calculate the removal order fee for any ASIN
        </p>
        <div className="first-free-badge">
          <span>Free</span> Amazon FBA Removal Fee Calculator
        </div>
      </header>
      
      <section className="calculator-section">
        <Calculator 
          onCalculate={onCalculate} 
          isRegistered={isRegistered} 
          userEmail={userEmail} 
          onShowSignupModal={onShowSignupModal} 
        />
      </section>
      
      <section className="info-section">
        <h2>Understanding Amazon FBA Removal Order Fees</h2>
        <p>
          Amazon charges fees for removing inventory from their fulfillment centers. 
          These fees vary based on the size, weight, and quantity of items being removed.
        </p>
        
        <div className="info-columns">
          <div className="info-column">
            <h3>Standard Size Items</h3>
            <div className="fee-list">
              <div className="fee-item">0 to 0.5 lb: $1.04 per unit</div>
              <div className="fee-item">0.5+ to 1.0 lb: $1.53 per unit</div>
              <div className="fee-item">1.0+ to 2.0 lb: $2.27 per unit</div>
              <div className="fee-item">More than 2 lb: $2.89 + $1.06/lb above 2 lb</div>
            </div>
          </div>
          
          <div className="info-column">
            <h3>Large Bulky Items</h3>
            <div className="fee-list">
              <div className="fee-item">0 to 1.0 lb: $3.12 per unit</div>
              <div className="fee-item">1.0+ to 2.0 lb: $4.30 per unit</div>
              <div className="fee-item">2.0+ to 4.0 lb: $6.36 per unit</div>
              <div className="fee-item">4.0+ to 10.0 lb: $10.04 per unit</div>
              <div className="fee-item">More than 10 lb: $14.32 + $1.06/lb above 10 lb</div>
            </div>
          </div>
        </div>
        
        <div className="faq-section">
          <h2>Frequently Asked Questions about Amazon Removal Orders</h2>
          
          <div className="faq-item">
            <h3>How much does Amazon charge for removal orders?</h3>
            <p>
              Amazon charges $1.04 and UP per unit for removal orders, 
              depending on the item's size and weight. Use our calculator above to get an accurate estimate.
            </p>
          </div>
          
          <div className="faq-item">
            <h3>What's the difference between disposal and return removal orders?</h3>
            <p>
              The fees are the same for both disposal and return removal orders. 
              Disposal means Amazon will dispose of your inventory, while return means 
              they'll ship it back to your designated address.
            </p>
          </div>
          
          <div className="faq-item">
            <h3>How are FBA removal order fees calculated?</h3>
            <p>
              Amazon calculates removal fees based on the item's size tier (standard or large/bulky) 
              and its shipping weight. The shipping weight is the greater of the unit's actual weight 
              or its dimensional weight.
            </p>
          </div>
          
          <div className="faq-item">
            <h3>Can I estimate my Amazon FBA removal order cost in advance?</h3>
            <p>
              Yes! Our calculator above provides accurate estimates of your removal order costs 
              based on Amazon's current fee structure. Simply enter your product's ASIN and quantity.
            </p>
          </div>
          
          <div className="faq-item">
            <h3>Where can I find Amazon's official removal fee policy?</h3>
            <p>
              Amazon's official removal fee policy can be found in the 
              <a href="https://sellercentral.amazon.com/gp/help/external/G201074400" target="_blank" rel="noopener noreferrer">
                Seller Central Help documentation (G201074400)
              </a>. 
              Our calculator uses the most current rates from this policy to ensure accurate estimates.
            </p>
          </div>
          
          <div className="faq-item">
            <h3>Why use this Amazon FBA removal fee calculator?</h3>
            <p>
              As the first dedicated calculator for Amazon FBA removal fees, we provide the most accurate 
              estimates based on Amazon's official rate card. Our calculator is completely free to use, 
              with no hidden costs or limitations. We're committed to helping Amazon sellers make informed 
              decisions about their inventory management.
            </p>
          </div>
        </div>
      </section>
      
      {!isRegistered && !userEmail && (
        <section className="cta-section">
          <h2>Save Time and Money on Your Amazon FBA Removal Orders</h2>
          <p>
            Sign up to save your calculation history and access advanced features to optimize your 
            Amazon FBA inventory management.
          </p>
          <button className="cta-button" onClick={onShowSignupModal}>
            Sign Up Now - It's Free!
          </button>
        </section>
      )}
      
      <footer className="seo-footer">
        <p>
          Our Amazon FBA Removal Order Fee Calculator helps sellers accurately estimate 
          removal order costs for their inventory. Whether you're planning disposal or return 
          removal orders, our tool provides instant calculations based on Amazon's official fee structure.
        </p>
        <p className="support-email">
          Need help? Contact us at <a href="mailto:support@tech-einc.com">support@tech-einc.com</a>
        </p>
        <p style={{ color: 'transparent', fontSize: 0, height: 0, overflow: 'hidden', margin: 0, padding: 0 }}>
          Keywords: amazon removal order, fba removal order fees, amazon fba removal order fees, 
          amazon removal order fee, fba removal order return fee, removal order fees amazon, 
          amazon removal order cost, fba removal order disposal fee
        </p>
      </footer>
    </div>
  );
}

export default HomePage; 